import { disputeViewSchema } from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const getDispute = {
  name: "getDispute" as const,
  input: z.object({ disputeId: z.coerce.bigint() }),
  output: z.object({ dispute: z.nullable(disputeViewSchema) }),
};
